import { useEffect } from "react";
import { InducteeLandingLoader, SEO } from "@components";
import { FaustTemplate, useFaustQuery } from "@faustwp/core";
import { usePageHighlight } from "@/providers/PageHighlightContext";
import { InducteeLandingQuery } from "@/queries/Pages/InducteeLanding";
import { InducteeLandingProvider } from "@/providers/InducteeLandingContext";
import {
  GetAllInducteesQuery,
  GetInducteeLandingQuery,
} from "@/__generated__/graphql";
import { getBasicQueryVars, getPageTitle } from "@/core/utils";
import { usePageLoading } from "@/providers/LoadingContext";
import { useTrackRouteChange } from "@/providers/TrackingContext";
import { usePageWrapperData } from "@/providers/PageWrapperContext";
import { HIGHLIGHT_COLORS } from "@/core/constants";

const InducteeLandingPage: FaustTemplate<any> = ({ loading }: FaustPageProps<any>) => {
  const pageData = useFaustQuery<GetInducteeLandingQuery>(InducteeLandingQuery);
  const { setHighlightColor } = usePageHighlight();
  const { siteTitle } = usePageWrapperData();
  const { previewLoading, setPreviewLoading } = usePageLoading();
  const pageSettings = pageData.rhPage.pageData;
  const { ogTitle, ogDescription, featuredImage, pageCategory } = pageSettings || {};
  const seoTitle = getPageTitle(siteTitle, ogTitle || pageData?.rhPage?.title);
  const [category] = pageCategory || [];
  useEffect(() => { setHighlightColor(HIGHLIGHT_COLORS.YELLOW); }, []);
  useTrackRouteChange(category?.slug);

  useEffect(() => {
    if (!loading && previewLoading) setPreviewLoading(false);
  }, [loading, previewLoading]);
  
  if (loading) return;

  return (
    <InducteeLandingProvider>
      <SEO title={seoTitle} description={ogDescription} image={featuredImage} />
      <InducteeLandingLoader inducteeLandingData={pageData?.rhPage?.inducteeLanding} />
    </InducteeLandingProvider>
  );
};

InducteeLandingPage.queries = [
  { query: InducteeLandingQuery, variables: getBasicQueryVars },
];

export default InducteeLandingPage;
